import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { UserIcon, UsersIcon, CrownIcon, XIcon } from 'lucide-react';
const mentorias = [{
  icon: UserIcon,
  title: 'Mentoría 1:1',
  problem: 'Sabes que puedes más, pero necesitas claridad, dirección y alguien que te vea de verdad.',
  methodology: 'Sesiones profundas de estrategia + trabajo de identidad + implementación guiada',
  includes: 'Sesiones semanales, acceso directo, revisión de estrategia, soporte entre sesiones',
  duration: '3 o 6 meses',
  results: 'Transformación acelerada con resultados medibles'
}, {
  icon: UsersIcon,
  title: 'Mentoría Grupal',
  problem: 'Quieres crecer en comunidad, con estructura y sin el costo de lo 1:1.',
  methodology: 'Sesiones grupales semanales + comunidad privada + implementación colectiva',
  includes: 'Acceso al grupo, sesiones en vivo, grabaciones, comunidad',
  duration: '12 semanas',
  results: 'Crecimiento sostenido + red de pares + resultados reales'
}, {
  icon: CrownIcon,
  title: 'Programa Premium',
  problem: 'Estás listo para el siguiente nivel. Quieres lo mejor, lo más completo, lo más transformador.',
  methodology: 'Acceso total al ecosistema + mentoría directa + comunidad de élite',
  includes: 'Todo incluido: programas, mentorías, comunidad, eventos, acceso ilimitado',
  duration: 'Anual',
  results: 'Transformación completa del negocio y la vida'
}];
export function Mentorias() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: '',
    message: ''
  });
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    setIsFormOpen(false);
    setFormData({
      name: '',
      email: '',
      whatsapp: '',
      message: ''
    });
  };
  return <>
      <section id="mentorias" ref={ref} className="py-24 md:py-32 bg-charcoal" data-id="element-188">
        <div className="max-w-7xl mx-auto px-6" data-id="element-189">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center mb-16" data-id="element-190">
            <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-191">
              Acompañamiento directo
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-192">
              Mentorías
            </h2>
            <p className="font-sans text-lg text-cream/70 font-light max-w-xl mx-auto" data-id="element-193">
              Para quienes están listos para ir más lejos, más rápido, con guía
              directa.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-194">
            {mentorias.map((mentoria, index) => <motion.div key={mentoria.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-charcoal-mid/30 border border-cream/10 rounded-3xl p-8 hover:border-gold/30 transition-colors duration-500" data-id="element-195">
                <div className="w-14 h-14 rounded-2xl bg-gold/10 flex items-center justify-center mb-6" data-id="element-196">
                  <mentoria.icon className="w-7 h-7 text-gold" data-id="element-197" />
                </div>

                <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-198">
                  {mentoria.title}
                </h3>

                <div className="space-y-5 mb-8" data-id="element-199">
                  <div data-id="element-200">
                    <span className="font-sans text-xs uppercase tracking-wider text-gold" data-id="element-201">
                      El problema
                    </span>
                    <p className="font-sans text-sm text-cream/80 mt-1 leading-relaxed" data-id="element-202">
                      {mentoria.problem}
                    </p>
                  </div>
                  <div data-id="element-203">
                    <span className="font-sans text-xs uppercase tracking-wider text-gold" data-id="element-204">
                      Metodología
                    </span>
                    <p className="font-sans text-sm text-cream/80 mt-1 leading-relaxed" data-id="element-205">
                      {mentoria.methodology}
                    </p>
                  </div>
                  <div data-id="element-206">
                    <span className="font-sans text-xs uppercase tracking-wider text-gold" data-id="element-207">
                      Incluye
                    </span>
                    <p className="font-sans text-sm text-cream/80 mt-1 leading-relaxed" data-id="element-208">
                      {mentoria.includes}
                    </p>
                  </div>
                  <div data-id="element-209">
                    <span className="font-sans text-xs uppercase tracking-wider text-gold" data-id="element-210">
                      Duración
                    </span>
                    <p className="font-sans text-sm text-cream/80 mt-1" data-id="element-211">
                      {mentoria.duration}
                    </p>
                  </div>
                  <div data-id="element-212">
                    <span className="font-sans text-xs uppercase tracking-wider text-gold" data-id="element-213">
                      Resultados
                    </span>
                    <p className="font-sans text-sm text-cream/80 mt-1 leading-relaxed" data-id="element-214">
                      {mentoria.results}
                    </p>
                  </div>
                </div>

                <button onClick={() => setIsFormOpen(true)} className="w-full py-3 bg-gold text-charcoal font-sans font-medium rounded-full hover:bg-gold-light transition-colors duration-300" data-id="element-215">
                  Aplicar ahora
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Application Modal */}
      <AnimatePresence data-id="element-216">
        {isFormOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-217">
            <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" onClick={() => setIsFormOpen(false)} data-id="element-218" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="relative w-full max-w-lg bg-cream rounded-3xl p-8 shadow-2xl" data-id="element-219">
              <button onClick={() => setIsFormOpen(false)} className="absolute top-4 right-4 p-2 text-charcoal-mid hover:text-charcoal transition-colors" aria-label="Cerrar" data-id="element-220">
                <XIcon className="w-5 h-5" data-id="element-221" />
              </button>

              <h3 className="font-serif text-2xl text-charcoal mb-2" data-id="element-222">
                Aplicar a Mentoría
              </h3>
              <p className="font-sans text-charcoal-mid mb-6" data-id="element-223">
                Cuéntame sobre ti y lo que buscas.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-224">
                <div data-id="element-225">
                  <label className="block font-sans text-sm text-charcoal mb-1" data-id="element-226">
                    Nombre
                  </label>
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="w-full px-4 py-3 bg-white border border-beige-dark rounded-xl font-sans text-charcoal focus:outline-none focus:border-gold transition-colors" data-id="element-227" />
                </div>
                <div data-id="element-228">
                  <label className="block font-sans text-sm text-charcoal mb-1" data-id="element-229">
                    Email
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-4 py-3 bg-white border border-beige-dark rounded-xl font-sans text-charcoal focus:outline-none focus:border-gold transition-colors" data-id="element-230" />
                </div>
                <div data-id="element-231">
                  <label className="block font-sans text-sm text-charcoal mb-1" data-id="element-232">
                    WhatsApp
                  </label>
                  <input type="tel" required value={formData.whatsapp} onChange={e => setFormData({
                ...formData,
                whatsapp: e.target.value
              })} className="w-full px-4 py-3 bg-white border border-beige-dark rounded-xl font-sans text-charcoal focus:outline-none focus:border-gold transition-colors" data-id="element-233" />
                </div>
                <div data-id="element-234">
                  <label className="block font-sans text-sm text-charcoal mb-1" data-id="element-235">
                    Cuéntame sobre tu situación actual y lo que buscas
                  </label>
                  <textarea required rows={4} value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} className="w-full px-4 py-3 bg-white border border-beige-dark rounded-xl font-sans text-charcoal focus:outline-none focus:border-gold transition-colors resize-none" data-id="element-236" />
                </div>
                <button type="submit" className="w-full py-4 bg-gold text-white font-sans font-medium rounded-full hover:bg-gold/90 transition-colors duration-300" data-id="element-237">
                  Enviar aplicación
                </button>
              </form>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}